import * as sharedActions from '../../../../../shared/store/collections/actions';

const collectionReducer =
    (collection) =>
    (state = collection, action = {}) => {
        const { type, data } = action;

        switch (type) {
            case sharedActions.COLLECTIONS_ACTIONS.UPDATE:
                return {
                    ...state,
                    ...data.collection,
                };
            default:
                return state;
        }
    };

export default collectionReducer;
